import * as yup from 'yup'

export enum ArkFoodsSalesOrderLineItemKeys {
  itemName = 'itemName',
  units = 'units',
  pricePerUnit = 'pricePerUnit',
}

const salesOrderSchema = yup.object().shape({
  itemName: yup.string().nullable().optional(),
  units: yup.string().nullable().optional(),
  pricePerUnit: yup.string().nullable().optional(),
})

export const arkFoodsPassingSheetFileDataSchema = yup.object().shape({
  customerName: yup.string().nullable().optional(),
  poNumber: yup.string().nullable().optional(),
  expectedDeliveryDate: yup.string().nullable().optional(),
  estimatedNumberOfPallets: yup.string().nullable().optional(),
  isFob: yup.string().nullable().optional(),
  items: yup.array().of(salesOrderSchema).required(),
})

export type ArkFoodsPassingSheetFileData = yup.InferType<typeof arkFoodsPassingSheetFileDataSchema>

export const arkFoodsPassingSheetFileDataMappings = {
  customerName: '9f2c3b18-7e4d-4a92-b3c6-2f5a8d1e7b44',
  poNumber: '7d1f3a26-5b8e-4c73-9a4b-2f6c8e1d4b90',
  expectedDeliveryDate: 'e94a27c5-91fd-4d3a-b8e1-3f2c7a64d5e8',
  estimatedNumberOfPallets: '0a6b5f41-2d9e-4e7a-bb14-7f6c2e3d9a5f',
  isFob: '4c8e1a72-6b3d-4f91-9e05-7a2d6c8b1f34',
  items: [
    {
      itemName: '8c3e4b27-7f5a-4d1c-a9d8-1b4f6e2c5a37',
      units: 'b9d7e8a2-6c1f-4b9d-8432-5e7f2a3c9d6b',
      pricePerUnit: 'f27a4c5b-3e1d-4f9a-8b7c-2d5e6a1f3c48',
    },
  ],
}
